import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface GenerateDocumentErgonomicWorkAnalysisParams {
	id: string;
	company_id: string;
	organization_id: string;
	locale: string;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useGenerateDocumentErgonomicWorkAnalysis = () => {
	return useMutation({
		mutationFn: async (params: GenerateDocumentErgonomicWorkAnalysisParams) => Service.generateDocument(params),
		onError: () => {
			message.error(I18n.get('Ops... something happened!'));
		}
	});
};
